import Badge from '../../base/Badge';
import React, { useEffect, useState } from 'react';
import { Project } from '../../../data/project-management/projects';
import { Card, ProgressBar } from 'react-bootstrap';
import Button from '../../base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import MachineCardControlModal from './MachineCardControlModal';
import useProjectProgress from '../../project-management/useProjectProgress';
import { feedStatus } from '../../../helpers/feedFreshness';
import {
  faChevronRight,
  faCreditCard,
  faListCheck,
  faUser
} from '@fortawesome/free-solid-svg-icons';

const CardViewItem = ({ machine }) => {
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const { progress, bgClassName, variant } = useProjectProgress(machine);

  return (
    <>
      <Card className="h-100 hover-actions-trigger">
        <Card.Body>
          <div className="d-flex align-items-center">
            <h4 className="mb-2 line-clamp-1 lh-sm flex-1 me-5">
              {machine.machine}
            </h4>
            <div className="hover-actions top-0 end-0 mt-4 me-4">
              <Button
                variant="primary"
                className="btn-icon flex-shrink-0"
                onClick={() => setOpenDetailsModal(true)}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </Button>
            </div>
          </div>
          {/* The status label is only meaningful if the values behind it are
              current. A frozen feed keeps whatever status it last had — that
              is how skip2250 sat at "inactive" for hours with nothing
              noticing. */}
          {(() => {
            const feed = feedStatus(machine);
            return feed.stale ? (
              <Badge variant="phoenix" bg="danger" className="fs-10 mb-4" title={feed.title}>
                feed dead {feed.label}
              </Badge>
            ) : (
              <Badge variant="phoenix" bg={machine.status.type} className="fs-10 mb-4" title={feed.title || undefined}>
                {machine.status.label}
              </Badge>
            );
          })()}
          <div className="d-flex align-items-center mb-2">
            <FontAwesomeIcon
              icon={faUser}
              className="me-2 text-700 fs-9 fw-extra-bold"
            />
            <p className="fw-bold mb-0 text-truncate lh-1">
              Operator :{' '}
              <span className="fw-semi-bold text-primary ms-1">
                {' '}
                {machine.operator}
              </span>
            </p>
          </div>
          <div className="d-flex align-items-center mb-4">
            <FontAwesomeIcon
              icon={faCreditCard}
              className="me-2 text-700 fs-9 fw-extra-bold"
            />
            <p className="fw-bold mb-0 text-truncate lh-1">
              Cable Length Produced :{' '}
              <span className="text-1100 ms-1">
                {machine.total_meter_produced.toFixed(2)} m
              </span>
            </p>
          </div>
          <div className="d-flex justify-content-between text-700 fw-semi-bold">
            <p className="mb-2"> Progress</p>
            <p className="mb-2 text-1100">{machine.progress.min}%</p>
          </div>
          <ProgressBar
            now={progress}
            className={classNames('flex-1', bgClassName)}
            variant={variant}
          />

          <div>
            <div className="d-flex align-items-center mt-4">
              <p className="mb-0 fw-bold fs-9">
                Started :
                <span className="fw-semi-bold text-600 ms-1">
                  {machine.start_machine_date}
                </span>
              </p>
            </div>
            <div className="d-flex align-items-center mt-2">
              <p className="mb-0 fw-bold fs-9">
                Active hours :{' '}
                <span className="fw-semi-bold text-600 ms-1">
                  {machine.active_hours}
                </span>
              </p>
            </div>

            <div className="d-flex d-lg-block d-xl-flex justify-content-between align-items-center mt-3">
              <div className="d-flex gap-1">
                <p className="mb-0 fw-bold fs-9">
                  Active shift :{' '}
                  <span className="fw-semi-bold text-600 ms-1">
                    {machine.shift}
                  </span>
                </p>
              </div>

              <div className="mt-lg-3 mt-xl-0">
                <FontAwesomeIcon icon={faListCheck} className="me-1" />

                <p className="d-inline-block fw-bold mb-0">
                  {machine.task}
                  <span className="fw-normal"> Task</span>
                </p>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>

      <MachineCardControlModal
        show={openDetailsModal}
        handleClose={() => setOpenDetailsModal(false)}
        machine={machine}
      />
    </>
  );
};

export default CardViewItem;
